import React, { FC } from 'react'
import { Button, Row, Col } from 'antd'
import { NotaryAcknowledgementActionsProps } from './types'

const NotaryAcknowledgementActions: FC<NotaryAcknowledgementActionsProps> = ({
  notaryAcknowledgement,
  submittingAck,
  onSubmit
}) => {
  if (notaryAcknowledgement) return null

  return (
    <Row gutter={[8, 8]} style={{ marginTop: 16 }}>
      <Col xs={24} sm={24} md={12}>
        <Button
          type="primary"
          loading={submittingAck}
          onClick={() => onSubmit('will_correct')}
          style={{
            width: '100%',
            backgroundColor: '#449d44',
            borderColor: '#398439'
          }}
        >
          I will correct these errors
        </Button>
      </Col>
      <Col xs={24} sm={24} md={12}>
        <Button
          type="primary"
          danger
          loading={submittingAck}
          onClick={() => onSubmit('request_clarification')}
          style={{ width: '100%' }}
        >
          I need clarification on these errors
        </Button>
      </Col>
    </Row>
  )
}

export default NotaryAcknowledgementActions
